import '../CSS/VersionMSA.css'

import React from 'react'

export function Version(props) {
  return (
    <div className='versionContainer'>{props.value}</div>
  )
}
